import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const cannyWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-canny/web/CannyPage',
    label: 'Add a Canny API key and default board as an org-scoped connection.',
  },
  agentContextProviders: [
    {
      id: 'agent-context-canny-posts',
      kind: 'canny-post',
      label: 'Canny ideas',
      keyword: 'canny',
      icon: 'Megaphone',
      componentPath: '@reflex/plugin-canny/web/CannyPostContextProvider',
      order: 70,
    },
  ],
  flowTriggerRenderers: [
    {
      triggerType: 'canny_post',
      label: 'Canny post created',
      icon: 'Megaphone',
      componentPath: '@reflex/plugin-canny/web/CannyFlowTriggerSummary',
    },
    {
      triggerType: 'canny_post_status',
      label: 'Canny post status changed',
      icon: 'Megaphone',
      componentPath: '@reflex/plugin-canny/web/CannyFlowTriggerSummary',
    },
  ],
};
